import { z } from 'zod';
import { THEME_PREFERENCES } from '@/app/theme';

export const ChatPositionSchema = z.enum(['right', 'footer', 'detached']);
export const ThemeSchema = z.enum(THEME_PREFERENCES);

/**
 * Form schema for the UserPreferences surface.
 * Maps 1-to-1 with the five allowed backend preference keys.
 */
export const UserPreferencesSchema = z.object({
  chatPosition: ChatPositionSchema,
  theme: ThemeSchema,
  locale: z.string().min(2).max(10),
  pinnedSurfaces: z.array(z.string()),
});

export type UserPreferencesFormValues = z.infer<typeof UserPreferencesSchema>;
